import React from 'react';
import { Link } from 'react-router-dom';

// third party
import Slider from 'react-slick';
import Avatar from 'react-avatar';

// project-imports
import { _setBgColor } from '../../utils';
import { useProductContext } from '../../context/product_context';
import { useTestimonialContext } from '../../context/testimonial_context';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';

// Child component
const PrevArrow = (props) => {
    const { onClick } = props;
    return <button className="slide-arrow prev-arrow slick-arrow" onClick={onClick}><i className="icon-arrow-left-line"></i></button>
}

const NextArrow = (props) => {
    const { onClick } = props;
    return <button className="slide-arrow next-arrow slick-arrow" onClick={onClick}><i className="icon-arrow-right-line"></i></button>
}

const TestimonialThree = (props) => {

    // Reading store data 
    let { testimonials } = useTestimonialContext();
    const { ebooks } = useProductContext();

    // constant variables
    const paid = ebooks?.filter((item) => item?.pricing.price > 0) || [];
    const ebooksProductCode = (paid || [])
        .filter(e => e?.productCode && e?.name)
        .map(e => ({
            productCode: String(e.productCode).trim().toLowerCase(),
            name: String(e.name).trim().toLowerCase()
        }));

    const classes = `eduvibe-testimonial-three inner testimonial-card-activation-1 slick-arrow-style-2 position-static ${props.className ? props.className : ''}`;

    const sliderSettings = {
        dots: props.dots === "enable" ? true : false,
        infinite: true,
        arrows: props.arrows === "disable" ? false : true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: props.fade === "disable" ? false : true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    };

    testimonials = props.item ? testimonials.slice(0, props.item) : testimonials;

    // constant fuctions
    const getNavigationUrl = (item) => {
        try {
            let isEBook = (item?.image && !item.image.toLowerCase().includes("1:1 salesforce consultation")) || (item?.email && !item.email.toLowerCase().includes("1:1 salesforce consultation"));
            let isConsult = (item?.image && item.image.toLowerCase().includes("1:1 salesforce consultation")) || (item?.email && item.email.toLowerCase().includes("1:1 salesforce consultation"));

            let type;

            if (isConsult) {
                triggerFunction(
                    GoogleAnalyticsEnum.BUTTON,
                    GoogleAnalyticsEnum.TESTIMONIAL_NAVIGATE_TO_GET_CONSULTATION
                );
                return `/get-free-consultation`;
            }

            if (isEBook) {
                let eBookDetail = (item && item?.image && item?.image?.toLowerCase()?.includes(":::") && item?.image?.split(":::")) || (item && item?.email && item?.email?.toLowerCase()?.includes(":::") && item?.email?.split(":::")) || [];
                let eBookCode = (eBookDetail[1] || "").trim().toLowerCase();
                let eBookName = (eBookDetail[2] || "").trim().toLowerCase();
                let isPaid = ebooksProductCode.some(
                    (ebook) =>
                        ebook.productCode === eBookCode &&
                        ebook.name === eBookName
                );

                type = isPaid ? "paid" : "free";
                triggerFunction(
                    GoogleAnalyticsEnum.BUTTON,
                    GoogleAnalyticsEnum.TESTIMONIAL_NAVIGATE_TO_EBOOK
                );
                // navigate(`/our-resources/${type}/${eBookCode}`);
                return `/our-resources/${type}/${eBookCode || ("").toLowerCase()}`;
            }

            return "/";
        } catch (error) {
            console.log("90 : TestimonialSalesforceV2 : Error in getNavigationUrl : ", error && JSON.stringify(error));
        }
    }

    const getLabel = (item) => {
        try {
            let isConsult = (item?.image && item.image.toLowerCase().includes("1:1 salesforce consultation")) || (item?.email && item.email.toLowerCase().includes("1:1 salesforce consultation"));
            return isConsult ? "Get Consultation" : "View E-Book";
        } catch (error) {
            console.log("99 : TestimonialSalesforceV2 : Error in getLabel : ", error && JSON.stringify(error));
        }
    }

    return (
        <Slider
            className={classes}
            {...sliderSettings}
        >
            {testimonials?.map((item, i) => (
                <div
                    className={props.itemClass || 'single-card'}
                    key={i}
                >
                    {props.rating !== 'disable' &&
                        <div className="rating eduvibe-course-rating-stars text-start">
                            {[...Array(5)].map((_, index) => {
                                return <i key={index} className={index < item.rating ? 'on icon-Star' : 'off icon-Star'}></i>
                            })}
                        </div>
                    }
                    <div className="client-info">
                        <div className="thumbnail">
                            {/* <img src={`${process.env.PUBLIC_URL}/images/testimonial/testimonial-04/${item.image}`} alt="Client Thumb" /> */}
                            <Avatar size='45' maxInitials={1} color={_setBgColor(item.name || "Guest User")} name={item?.name || "Guest User"} textSizeRatio={2.25} round />
                        </div>

                        <div className="content text-start">
                            <h6 className="title">{item.name}</h6>
                            <span className="designation">{item.designation}</span>
                        </div>
                    </div>
                    <p className="description mb--20 testimonial-container text-start">“{props.details2 !== "enable" ? item.details : item.details}”</p>
                    <div className="text-start">
                        <Link className="btn-transparent color-primary" to={getNavigationUrl(item)} >{getLabel(item)}<i className="icon-arrow-right-line-right"></i></Link>
                    </div>
                </div>
            ))}
        </Slider>
    )
}

export default TestimonialThree;